module.exports = __webpack_public_path__ + "img/super-man.5276baae.svg";